import React, { useEffect, useState } from "react";
import "./CartLoadCard.css";
import ribbon from "../../assets/ribbon.svg";
import loader from "../../assets/loader.gif"; // ✅ loader image
import flower from "../../assets/flower-pattern.svg";
import flowerLeft from "../../assets/flower-left.svg";
import { useNavigate } from "react-router-dom";
import { useAllProduct } from "../../components/api-context/commonApiContext";
import Config from "../../config/Config";

const CartLoadCard = () => {
  const {
    merchantInfo,
    moneyLoadStatus,
    setIntentLink,
    isLoading,
    setIsLoading,
  } = useAllProduct();

  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  // 🟢 Handle redeem action
  const handleRedeemClick = async () => {
    if (moneyLoadStatus === "pending") {
      try {
        setIsLoading(true); // ✅ show loader

        const response = await fetch(`${Config.node_api_endpoint}/load-money`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": process.env.REACT_APP_API_KEY,
          },
          body: JSON.stringify({
            amount: merchantInfo.amount,
            merchant_id: merchantInfo.merchant_id,
            merchant_id_d: merchantInfo.merchant_id_d,
            payment_id: merchantInfo.payment_id,
          }),
        });

        const data = await response.json();
        console.log("Backend response:", data);

        const intentLink = data.intent_link;
        localStorage.setItem("intentLink", intentLink);
        setIntentLink(intentLink);

        navigate("/payment", { state: { intentLink } });
        // ✅ Hide loader and navigate
        setIsLoading(false);
      } catch (error) {
        console.error("Error loading money:", error);
        setIsLoading(false);
      }
    }
    if (moneyLoadStatus === "completed") {
      setShowConfirm(true);
    }
  };

  // 🟢 Confirm popup handlers
  const handleConfirmYes = async () => {
    setShowConfirm(true);
    try {
      setIsLoading(true); // ✅ show loader

      const response = await fetch(`${Config.node_api_endpoint}/redeem`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({
          merchant_id: merchantInfo.merchant_id,
          merchant_id_d: merchantInfo.merchant_id_d,
          payment_id: merchantInfo.payment_id,
          amount: merchantInfo.amount,
        }),
      });

      const data = await response.json();

      if (!data.success) {
        console.error("Failed to Reedem:", data);
        setIsLoading(false);
        setShowConfirm(false);
        return;
      }
      if (data.redirect_url) {
        console.log("Redirecting to:", data.redirect_url);
        window.location.href = data.redirect_url; // open encoded link
      }
      setIsLoading(false);
      setShowConfirm(false);
    } catch (error) {
      console.error("Error loading money:", error);
      setIsLoading(false);
      setShowConfirm(false);
    }
  };

  const handleConfirmNo = () => {
    setShowConfirm(false);
  };

  console.log("moneyLoadStatus", moneyLoadStatus);

  return (
    <div className="cart-page">
      <div className="cart-card">
        <div className="card-header mb-3">
          <img src={ribbon} alt="Ribbon" className="ribbon" />
        </div>

        <div className="card-body">
          <h3 className="welcome px-2">
            Welcome to <span className="brand">Khazana Card</span>
          </h3>

          <div className="cart-row px-2">
            <span className="cart-label">Cart amount</span>
            <span className="cart-value">₹{merchantInfo.amount}</span>
          </div>

          <div className="divider mt-2" />
          <img src={flowerLeft} alt="Flower" className="flower flower-left" />
          <img src={flower} alt="Flower" className="flower flower-right" />

          <button className="load-btn w-100" onClick={handleRedeemClick}>
            {moneyLoadStatus === "completed" ? "Redeem now" : "Load Money"}
          </button>

          {isLoading && (
            <div className="floating-loader">
              <div className="floating-loader-box">
                <img
                  src={loader}
                  alt="Loading..."
                  className="floating-loader-gif"
                />
                <p className="floating-loader-text">Loading...</p>
              </div>
            </div>
          )}
          {/* 🟢 Popup Modal */}
          {showConfirm && (
            <div className="confirm-overlay">
              <div className="confirm-popup">
                <p style={{ color: "#2348AB" }}>
                  Are you sure you want to redeem this product?
                </p>
                <div className="btn-row">
                  <button className="btn-no" onClick={handleConfirmNo}>
                    No
                  </button>
                  <button className="btn-yes" onClick={handleConfirmYes}>
                    Yes
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CartLoadCard;
